module.exports = __webpack_public_path__ + "img/login-bottom2.d5f46d70.png";